import { InteractiveContainer, Collapse } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React, { ReactNode, useState } from "react";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

type CustomerInfoCollapseSectionProps = {
  title: string;
  icon: ReactNode;
  initialIsOpen?: boolean;
  isCollapsible?: boolean;
  endAdornment?: ReactNode;
  children: ReactNode;
};

export const CustomerInfoCollapseSection: React.FC<
  CustomerInfoCollapseSectionProps
> = ({
  title,
  icon,
  initialIsOpen = true,
  isCollapsible = true,
  endAdornment,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen);

  const header = (
    <div className="flex w-full items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2">
        {icon}
        <span className="truncate font-secondary text-sm font-medium text-dark">
          {title}
        </span>
      </div>
      <div className="flex items-center gap-3">
        {endAdornment}
        {isCollapsible && (
          <ChevronIcon
            className={cx(
              "shrink-0 transition-transform",
              isOpen && "rotate-180"
            )}
          />
        )}
      </div>
    </div>
  );

  return (
    <div className="px-6">
      {isCollapsible ? (
        <InteractiveContainer
          onClick={() => setIsOpen((prev) => !prev)}
          className="flex w-full"
        >
          {header}
        </InteractiveContainer>
      ) : (
        <div className="flex w-full">{header}</div>
      )}
      {isCollapsible ? (
        <Collapse isOpen={isOpen} unmountOnExit={false}>
          <div className="px-3 pt-6">{children}</div>
        </Collapse>
      ) : (
        <div className="px-3 pt-3 pb-6">{children}</div>
      )}
    </div>
  );
};
